var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8RequestService50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M37,39H11l-6,6V11c0-3.3,2.7-6,6-6h26c3.3,0,6,2.7,6,6v22C43,36.3,40.3,39,37,39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004d40",
    d: "M33.414,29.586l-7.636-7.636l-2.828,2.828l7.636,7.636C30.977,32.805,31.488,33,32,33 c0.512,0,1.023-0.195,1.414-0.586S34,31.512,34,31S33.805,29.977,33.414,29.586z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M25.21 22.79L23.79 24.21 16.59 17 15.14 17 13 13.43 14.43 12 18 14.14 18 15.59z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdbdbd",
    d: "M25.2,22.79l-3.32-3.32l-1.41,1.41l3.32,3.33L25.2,22.79z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M36,16.5c0,3.04-2.46,5.5-5.5,5.5c-0.79,0-1.53-0.17-2.21-0.46L17.41,32.41 C17.02,32.8,16.51,33,16,33s-1.02-0.2-1.41-0.59c-0.395-0.39-0.593-0.9-0.593-1.41c0-0.51,0.198-1.02,0.593-1.41l10.87-10.88 C25.17,18.03,25,17.29,25,16.5c0-3.04,2.46-5.5,5.5-5.5c0.79,0,1.53,0.17,2.21,0.46l-4.7,4.7l2.83,2.83l4.7-4.7 C35.83,14.97,36,15.71,36,16.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8RequestService50);
export default __webpack_public_path__ + "static/media/icons8-request-service-50.135c2aaa68e1913cbb8b15ff43767465.svg";
export { ForwardRef as ReactComponent };